import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Dialog, Input, Select, Textarea } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { boiteApi } from '../../api/boite-reception.js';
import { useShellContext } from '../shell/context.js';
import { Field } from '../Field.js';
import { useGesteBoite } from './useGesteBoite.js';
import styles from './Boite.module.css';
export function NouvelEmailDialog({
  contact,
  onOpenChange,
}: {
  contact: { id: string; emails: readonly string[] };
  onOpenChange: (v: boolean) => void;
}) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation(['regie', 'commun']);
  const navigate = useNavigate();
  const [adresse, setAdresse] = useState(contact.emails[0] ?? '');
  const [sujet, setSujet] = useState('');
  const [texte, setTexte] = useState('');
  const [pieces, setPieces] = useState<File[]>([]);
  const envoyer = useGesteBoite((_: void, appel) =>
    boiteApi.composer(
      galerieSlug,
      '/nouveau',
      { contactId: contact.id, adresse, sujet, texte },
      pieces,
      appel,
    ),
  );
  const piecesValides =
    pieces.length <= 5 && pieces.reduce((s, f) => s + f.size, 0) <= 10 * 1024 * 1024;
  const valide = adresse && sujet.trim() && texte.trim() && piecesValides;
  async function soumettre() {
    if (!valide) return;
    const r = await envoyer.executer();
    if (r) {
      onOpenChange(false);
      void navigate(`/${galerieSlug}/boite-reception/${r.message.conversationId}`);
    }
  }
  return (
    <Dialog
      open
      onOpenChange={onOpenChange}
      title={t('regie:boiteReception.ecrireEmail')}
      description={t('regie:boiteReception.nouvelEmailDescription')}
      closeLabel={t('commun:actions.fermer')}
    >
      <form
        className={styles.formulaire}
        onSubmit={(e) => {
          e.preventDefault();
          void soumettre();
        }}
      >
        <Field htmlFor="email-adresse" label={t('regie:boiteReception.destinataire')}>
          <Select
            id="email-adresse"
            value={adresse}
            onValueChange={setAdresse}
            options={contact.emails.map((value) => ({ value, label: value }))}
          />
        </Field>
        <Field htmlFor="email-sujet" label={t('regie:boiteReception.sujet')}>
          <Input
            id="email-sujet"
            maxLength={500}
            required
            value={sujet}
            onChange={(e) => setSujet(e.target.value)}
          />
        </Field>
        <Field htmlFor="email-texte" label={t('regie:boiteReception.texte')}>
          <Textarea
            id="email-texte"
            maxLength={50000}
            required
            value={texte}
            onChange={(e) => setTexte(e.target.value)}
          />
        </Field>
        <Field htmlFor="email-pieces" label={t('regie:boiteReception.piecesLabel')}>
          <Input
            id="email-pieces"
            type="file"
            multiple
            onChange={(e) => setPieces(Array.from(e.target.files ?? []))}
          />
        </Field>
        {!piecesValides ? <p role="alert">{t('regie:boiteReception.limitePieces')}</p> : null}
        {envoyer.erreur ? <p role="alert">{envoyer.erreur}</p> : null}
        <Button type="submit" loading={envoyer.pending} disabled={!valide}>
          {t('regie:boiteReception.envoyer')}
        </Button>
      </form>
    </Dialog>
  );
}
